export default __webpack_public_path__ + "static/media/Website-Passcode-Banner-new.787d0170.jpg";